module.exports = __webpack_public_path__ + "img/trial-period.1f207d90.png";